import PropTypes from 'prop-types';
import { NAV_BACK_BUTTON } from 'src/common/constants/localizations/button';
import assetUrl from 'src/common/utils/assetUrl';
import css from './back-arrow.module.scss';

const leftArrowSrc = assetUrl('assets/img/shared/arrow-left.svg');

export function BackArrow({ getLocalizedText, goBack }) {
  return (
    <button
      type="button"
      className={css.backButton}
      aria-label={getLocalizedText(NAV_BACK_BUTTON)}
      onClick={goBack}
    >
      {/* The empty alt below is intentional, as screen readers will use the aria-label on the button */}
      <img
        src={leftArrowSrc}
        width="30"
        height="30"
        role="presentation"
        alt=""
      />
    </button>
  );
}

BackArrow.propTypes = {
  getLocalizedText: PropTypes.func,
  goBack: PropTypes.func,
};
